import {
  Container,
  Grid,
  Box,
  Alert,
  Snackbar,
  Backdrop,
  CircularProgress,
  Typography,
  Paper,
  TextField,
  InputAdornment,
  Icon,
  MenuItem,
  Button,
  Card,
  Divider,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Autocomplete,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckoutFooter from "../components/footer";
import AppConfig from "../../appConfig";
import axios from "../../axios";
import usePageTitle from "../pageTitle";
import FormSectionBuilder from "../components/data_forms/form_section_builder";
import { useGeolocated } from "react-geolocated";
import GoogleAddressField from "../components/google_address";

function CampaignCheckout() {
  const [pageTitle, setPageTitle] = useState("Checkout");
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);

  const [banner, setBanner] = useState(null);
  const [webStore, setWebStore] = useState(null);
  const [campaign, setCampaign] = useState(null);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [campaignPaymentMethods, setCampaignPaymentMethods] = useState([]);
  const [showPaymentMethods, setShowPaymentMethods] = useState(false);
  const [shippingRequired, setShippingRequired] = useState(false);
  const [customerRequired, setCustomerRequired] = useState(true);

  const [showInlineLoading, setShowInlineLoading] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [dataForm, setDataForm] = useState(null);
  const [dataFormSections, setDataFormSections] = useState([]);

  const [productImages, setProductImages] = useState([]);
  const [productIndex, setActiveStep] = useState(0);
  const [productImageSize, setProductImageSize] = useState(0);
  const [campaignProductVariants, setCampaignProductVariants] = useState([]);
  const [selectCampaignProductVariants, setSelectCampaignProductVariants] = useState([]);
  const [tempSelectedVariants, setTempSelectedVariants] = useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [selectedProductAmount, setSelectedProductAmount] = useState(0);

  const [selectedProductObject, setSelectedProductObject] = useState(null);
  const [showProductDialog, setShowProductDialog] = useState(false);
  const [checkoutProducts, setCheckoutProducts] = useState([]);

  const [autocompleteOptions, setAutocompleteOptions] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);

  const [shippingRate, setShippingRate] = useState(null);
  const [shippingStates, setShippingStates] = useState([]);
  const [shippingStateOptions, setShippingStateOptions] = useState([]);
  const [selectedShippingState, setSelectedShippingState] = useState(null);
  const [selectedShippingStateOption, setSelectedShippingStateOption] = useState(null);

  const [shippingRecipientName, setShippingRecipientName] = useState(null);
  const [shippingRecipientPhoneNumber, setShippingRecipientPhoneNumber] = useState(null);
  const [shippingCity, setShippingCity] = useState(null);
  const [shippingState, setShippingState] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [shippingLatitude, setShippingLatitude] = useState(null);
  const [shippingLongitude, setShippingLongitude] = useState(null);

  const [customerPool, setCustomerPool] = useState(null);
  const [customerPoolValue, setCustomerPoolValue] = useState(null);

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      alert("NONE");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`checkout/campaign/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            // console.log(result.data.data);
            setBanner(result.data.data.banner);
            setWebStore(result.data.data.webstore);
            setCampaign(result.data.data.campaign);
            setProducts(result.data.data.campaign.products);

            setCurrency(result.data.data.campaign.currency);
            setCampaignPaymentMethods(result.data.data.payment_methods);
            if (result.data.data.campaign.payment_required) {
              setShowPaymentMethods(true);
            } else {
              setShowPaymentMethods(false);
              setPaymentMethod("FREE");
            }
            setCustomerRequired(result.data.data.campaign.is_customer_required);

            if (result.data.data.campaign.data_form !== null) {
              setDataForm(result.data.data.campaign.data_form);
            }

            let prds = [];
            for (let prd of result.data.data.campaign.products) {
              prds.push({
                label: prd.title,
                id: prd.reference,
              });
            }
            setAutocompleteOptions(prds);
            setShippingRequired(result.data.data.campaign.is_shipping_required);
            if (result.data.data.campaign.shipping_rate !== null) {
              let states = [];
              for (const [key, value] of Object.entries(
                result.data.data.campaign.shipping_rate.rates
              )) {
                // console.log(key, value);
                states.push({ reference: key, title: value.title });
              }

              // console.log(states);

              setShippingRate(result.data.data.campaign.shipping_rate);
              setShippingStates(states);
            }
            setCustomerPool(result.data.data.campaign.customer_pool);
            //console.log(customerPool);

            let bizName =
              result.data.data.webstore !== null
                ? result.data.data.webstore.title
                : result.data.data.campaign.account.name;
            setPageTitle(`${bizName} | ${result.data.data.campaign.title}`);

            // Handle App Update
            const currentVersion = localStorage.getItem(AppConfig.app_version_store);
            const newVersion = result.data.version;
            if (currentVersion !== newVersion) {
              localStorage.setItem(AppConfig.app_version_store, newVersion);
              if (window.confirm("New version available. Reloading...") === true) {
                window.location.reload(true);
              } else {
                window.location.reload(true);
              }
              return;
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  useEffect(() => {
    setSelectedShippingStateOption(null);
    if (selectedShippingState === null) {
      return;
    }
    setShippingStateOptions(shippingRate.rates[selectedShippingState].options);
  }, [selectedShippingState]);

  useEffect(() => {
    if (selectedProduct === null) {
      return;
    }

    setActiveStep(0);
    setSelectedQuantity(1);
    setSelectCampaignProductVariants([]);
    setCampaignProductVariants([]);
    products.every((prd) => {
      if (prd.reference === selectedProduct) {
        // console.log(prd);
        setSelectedProductObject(prd);
        setCampaignProductVariants(prd.variants);
        setProductImages(prd.images);
        setProductImageSize(prd.images.length);
        setShowProductDialog(true);
      }
      return true;
    });
  }, [selectedProduct]);

  useEffect(() => {
    const sections = [];
    if (dataForm === null) {
      return;
    }

    dataForm.form.form.sections.every(async (param) => {
      // console.log(param);
      const sect = <FormSectionBuilder section={param} />;
      sections.push(sect);
      return false;
    });
    // console.log(sections);
    setDataFormSections(sections);
  }, [dataForm]);

  const goToNextPicture = () => {
    if (productIndex === productImageSize - 1) {
      setActiveStep(0);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const goBackToPicture = () => {
    if (productIndex === 0) {
      setActiveStep(productImageSize - 1);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  useEffect(() => {
    let tAmt = 0;
    checkoutProducts.every((prd) => {
      tAmt += prd.amount;
      return true;
    });
    setTotalAmount(tAmt);
  }, [JSON.stringify(checkoutProducts)]);

  function addToCart() {
    const tNum = Number(selectedQuantity);
    if (!tNum) {
      setErrMsg("Invalid product quantity");
      setSeverity("error");
      setOpen(true);
      return;
    }

    if (parseInt(selectedQuantity, 10) <= 0) {
      setErrMsg("Product quantity is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    if (selectedProductObject.order_quantity > 0) {
      if (selectedQuantity > selectedProductObject.order_quantity) {
        setErrMsg(`Product quantity can not be more than ${selectedProductObject.order_quantity}`);
        setSeverity("error");
        setOpen(true);
        return;
      }
    }

    let prdtAmt = selectedProductObject.price;
    if (!selectedProductObject.is_price_fixed) {
      if (selectedProductAmount < selectedProductObject.price_minimum / 100) {
        setErrMsg(
          `Amount can not be less than ${currency.symbol}${(
            selectedProductObject.price_minimum / 100
          ).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        );
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (selectedProductObject.price_maximum > 0) {
        if (selectedProductAmount > selectedProductObject.price_maximum / 100) {
          setErrMsg(
            `Amount can not be more than ${currency.symbol}${(
              selectedProductObject.price_maximum / 100
            ).toLocaleString("en", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          );
          setSeverity("error");
          setOpen(true);
          return;
        }
      }

      prdtAmt = selectedProductAmount * 100;
      if (prdtAmt <= 0) {
        setErrMsg("Invalid amount entered.");
        setSeverity("error");
        setOpen(true);
        return;
      }
    }

    if (campaignProductVariants.length > 0) {
      if (campaignProductVariants.length !== selectCampaignProductVariants.length) {
        setErrMsg("All product option(s) are required.");
        setSeverity("error");
        setOpen(true);
        return;
      }
    }

    const productToAdd = {
      reference: selectedProductObject.reference,
      name: selectedProductObject.title,
      quantity: selectedQuantity,
      amount: prdtAmt * selectedQuantity,
      image: productImageSize > 0 ? productImages[0] : banner,
      variants: selectCampaignProductVariants,
    };

    if (checkoutProducts.length <= 0) {
      let tChckPrdts = checkoutProducts;
      tChckPrdts.push(productToAdd);
      setCheckoutProducts(tChckPrdts);
      setSelectedProduct(null);
      setSelectedProductObject(null);
      setShowProductDialog(false);

      setErrMsg("Item added successfully");
      setSeverity("success");
      setOpen(true);
      return;
    }

    let tempCheckoutProducts = checkoutProducts;

    // Check if product was been added
    let prdIndexes = [];
    tempCheckoutProducts.every((prd, index) => {
      if (prd.reference === selectedProductObject.reference) {
        prdIndexes.push(index);
      }
      return true;
    });

    // Check variants of the pre-added product
    if (prdIndexes.length > 0) {
      // Restrict SINGLE SETS
      if (selectedProductObject.order_restriction === "SINGLE") {
        setErrMsg("Product is restricted to one per order.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      let same = true;
      for (let val of prdIndexes) {
        let tempCheckoutVariants = tempCheckoutProducts[val].variants;
        // console.log(tempCheckoutVariants);
        // console.log(selectCampaignProductVariants);

        let differs = false;

        for (const [j, pVariant] of selectCampaignProductVariants.entries()) {
          let inDiffers = false;
          for (const [k, yVariant] of tempCheckoutVariants.entries()) {
            if (pVariant.reference !== yVariant.reference) {
              continue;
            }

            // console.log(
            //   `${pVariant.reference} | ${pVariant.option} | ${yVariant.option}`
            // );
            if (pVariant.option !== yVariant.option) {
              inDiffers = true;
            }
          }

          if (inDiffers) {
            differs = true;
          }
        }

        if (!differs) {
          tempCheckoutProducts[val].variants = selectCampaignProductVariants;
          tempCheckoutProducts[val].quantity = selectedQuantity;
          tempCheckoutProducts[val].amount = selectedProductObject.price * selectedQuantity;
        } else {
          same = false;
        }
      }

      if (!same) {
        tempCheckoutProducts.push(productToAdd);
      }
    } else {
      tempCheckoutProducts.push(productToAdd);
    }

    setCheckoutProducts(tempCheckoutProducts);
    setSelectedProduct(null);
    setSelectedProductObject(null);
    setShowProductDialog(false);

    setErrMsg("Item added successfully");
    setSeverity("success");
    setOpen(true);
    return;
  }

  function removeFromCart(index) {
    console.log(index);
    let tempCheckoutProducts = checkoutProducts;
    tempCheckoutProducts.splice(index, 1);
    setCheckoutProducts(tempCheckoutProducts);

    setErrMsg("Item removed");
    setSeverity("success");
    setOpen(true);
    return;
  }

  const { coords, isGeolocationAvailable, isGeolocationEnabled } = useGeolocated({
    positionOptions: {
      enableHighAccuracy: true,
    },
    userDecisionTimeout: 5000,
  });

  function getGPSCoords() {
    if (!isGeolocationAvailable) {
      return false;
    }

    if (!isGeolocationEnabled) {
      return false;
    }

    if (coords) {
      return { latitude: coords.latitude, longitude: coords.longitude };
    }

    return false;
  }

  function getFormFieldDisplayName(fieldRef) {
    if (dataForm === null) {
      return "Unknown field";
    }

    let dName = "";
    dataForm.form.form.sections.every((section) => {
      section.fields.every((field) => {
        if (field.reference === fieldRef) {
          dName = `${field.display_name} (${section.title})`;
        }
        return true;
      });
      return true;
    });

    return dName ? dName : false;
  }

  function preprocessDataForm() {
    /* eslint-disable no-restricted-syntax */

    const dForm = document.querySelector(`#dataForm`);
    const data = new FormData(dForm);
    console.log(...data);

    for (const entry of data.entries()) {
      // if ("search_name_input")
      if (entry[1].length <= 0) {
        setSeverity("error");
        // setErrMsg(`${entry[0].charAt(0).toUpperCase()}${entry[0].slice(1)}  is required`);
        // setErrMsg(
        //   `${entry[0].charAt(0).toUpperCase()}${entry[0]
        //     .slice(1)
        //     .replace(/_/g, " ")}  is required`
        // );
        // console.log(entry[0]);
        const dF_fieldName = getFormFieldDisplayName(entry[0]);
        if (dF_fieldName === false) {
          continue;
        }
        setErrMsg(`${dF_fieldName} is required`);
        setOpen(true);
        return false;
      }
    }

    const values = Object.fromEntries(data.entries());
    // const postJson = JSON.stringify(values);
    return values;
  }

  async function buy() {
    let lat = null;
    let lng = null;
    const gpsCoords = getGPSCoords();
    if (campaign.enforce_location_capture) {
      if (!gpsCoords) {
        setSeverity("error");
        setErrMsg("Please enable and allow browser's location and GPS access.");
        setOpen(true);
        return;
      }
    }

    // Collect if captured
    if (gpsCoords) {
      lat = gpsCoords.latitude;
      lng = gpsCoords.longitude;
    }

    if (checkoutProducts.length <= 0) {
      setSeverity("error");
      setErrMsg("Please select a product.");
      setOpen(true);
      return;
    }

    let dataFormValues = {};
    if (dataForm !== null) {
      const values = preprocessDataForm();
      if (values === false) {
        return;
      }
      dataFormValues = {
        reference: dataForm.reference,
        data: values,
      };
    }
    // console.log(dataFormValues);

    if (shippingRequired) {
      if (shippingRecipientName === null || shippingRecipientName.length < 3) {
        setSeverity("error");
        setErrMsg("Shipping receiver's name required");
        setOpen(true);
        return;
      }

      if (shippingRecipientPhoneNumber === null || shippingRecipientPhoneNumber.length < 3) {
        setSeverity("error");
        setErrMsg("Shipping receiver's phone number required");
        setOpen(true);
        return;
      }

      if (shippingAddress === null || shippingLatitude === null || shippingLongitude === null) {
        setSeverity("error");
        setErrMsg("Shipping address required");
        setOpen(true);
        return;
      }

      if (shippingRate === null) {
        if (shippingCity === null || shippingCity.length < 3) {
          setSeverity("error");
          setErrMsg("Shipping city required");
          setOpen(true);
          return;
        }

        if (shippingState === null || shippingState.length < 3) {
          setSeverity("error");
          setErrMsg("Shipping state required");
          setOpen(true);
          return;
        }
      }
    }

    let shippingOption = null;
    if (shippingRate !== null) {
      if (selectedShippingState === null || selectedShippingStateOption === null) {
        setSeverity("error");
        setErrMsg("Please select your shipping location");
        setOpen(true);
        return;
      }

      shippingOption = {
        reference: shippingRate.reference,
        state: selectedShippingState,
        option: selectedShippingStateOption,
      };
    }

    if (customerRequired === true) {
      if (firstName === null) {
        setSeverity("error");
        setErrMsg("Customer first name required");
        setOpen(true);
        return;
      }

      if (lastName === null) {
        setSeverity("error");
        setErrMsg("Customer last name required");
        setOpen(true);
        return;
      }

      if (emailAddress === null) {
        setSeverity("error");
        setErrMsg("Customer email address required");
        setOpen(true);
        return;
      }

      if (phoneNumber === null) {
        setSeverity("error");
        setErrMsg("Customer phone number required");
        setOpen(true);
        return;
      }
    }

    if (paymentMethod === null) {
      setSeverity("error");
      setErrMsg("Payment method required.");
      setOpen(true);
      return;
    }

    if (window.confirm("Are you sure you want to proceed?") === false) {
      return;
    }

    setShowLoading(true);
    const json = {
      reference: ref,
      products: checkoutProducts,
      payment_method: paymentMethod,
      customer: {
        first_name: firstName,
        last_name: lastName,
        email_address: emailAddress,
        phone_number: phoneNumber,
        // mobile_network: `${network}`,
      },
      campaign: `${campaign}`,
      latitude: lat,
      longitude: lng,
      // latitude: gpsCoords ? gpsCoords.latitude : null,
      // longitude: gpsCoords ? gpsCoords.longitude : null,
      data_form: dataForm !== null ? dataFormValues : null,
      shipping_option: shippingOption,
      shipping_info: {
        name: shippingRecipientName,
        phone_number: shippingRecipientPhoneNumber,
        address: shippingAddress,
        latitude: shippingLatitude,
        longitude: shippingLongitude,
        state: shippingState,
        city: shippingCity,
      },
      customer_pool_key: customerPoolValue,
    };

    await axios
      .post("checkout/campaign/checkout.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          window.location.href = result.data.data.redirect_url;
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <>
      <Box mb={5}>
        <Container>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showLoading}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
              {errorMsg}
            </Alert>
          </Snackbar>

          {selectedProductObject !== null ? (
            <Dialog open={showProductDialog} fullWidth maxWidth="md">
              <DialogTitle>
                <Box mt={2} align="center">
                  <Typography>
                    {selectedProductObject.title}
                    {selectedProductObject.is_price_fixed ? (
                      <span>
                        <br />
                        {currency.symbol}
                        {(selectedProductObject.price / 100).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    ) : (
                      <> </>
                    )}
                  </Typography>
                </Box>
              </DialogTitle>
              <Box mb={0}>
                <Divider />
              </Box>
              <DialogContent>
                <Box mb={3}>
                  <Box elevation={3}>
                    <Box p={0}>
                      <Box mt={1}>
                        {productImageSize > 0 ? (
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              md={6}
                              lg={6}
                              sx={{
                                display: {
                                  xs: "flex",
                                  sm: "flex",
                                  md: "flex",
                                },
                                flexDirection: "column",
                                backgroundColor: "background.paper",
                                borderRight: { sm: "none", md: "1px solid" },
                                borderColor: { sm: "none", md: "divider" },
                                alignItems: "start",
                                pt: { xs: -4, md: 4 },
                                px: { xs: 1, sm: 3 },
                                gap: { xs: 0, md: 4 },
                              }}
                            >
                              <Box p={0} align="center">
                                <Box>
                                  <img
                                    src={`${AppConfig.api_media_url}${productImages[productIndex]}`}
                                    alt="img"
                                    width="70%"
                                    maxWidth="100px"
                                  />
                                </Box>
                                {productImageSize > 1 ? (
                                  <Box mt={2} mb={3}>
                                    <Grid container spacing={3}>
                                      <Grid item xs={6} md={6} lg={6}>
                                        <Box align="left">
                                          <Button
                                            onClick={goBackToPicture}
                                            variant="outlined"
                                            iconOnly
                                            color="primary"
                                            size="small"
                                          >
                                            <Icon>keyboard_arrow_left</Icon>
                                          </Button>
                                        </Box>
                                      </Grid>
                                      <Grid item xs={6} md={6} lg={6}>
                                        <Box align="right">
                                          <Button
                                            variant="outlined"
                                            onClick={goToNextPicture}
                                            iconOnly
                                            color="primary"
                                            size="small"
                                          >
                                            <Icon>keyboard_arrow_right</Icon>
                                          </Button>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                ) : (
                                  <> </>
                                )}
                              </Box>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <Box>
                                {!selectedProductObject.is_price_fixed ? (
                                  <Box mt={3} mb={3}>
                                    <Box px={0}>
                                      <Typography variant="caption" fontWeight="regular">
                                        ENTER AMOUNT
                                      </Typography>
                                    </Box>
                                    <Box mt={3}>
                                      <TextField
                                        sx={{
                                          size: {
                                            xs: "small",
                                            md: "large",
                                            lg: "large",
                                          },
                                        }}
                                        // value={selectedProductAmount}
                                        type="decimal"
                                        label="Amount"
                                        fullWidth
                                        onChange={(e) =>
                                          setSelectedProductAmount(parseFloat(e.target.value, 10))
                                        }
                                      />
                                    </Box>
                                  </Box>
                                ) : (
                                  <> </>
                                )}
                                {campaignProductVariants.length > 0 ? (
                                  <Box>
                                    {/* <Box mb={3}>
                                        <Divider />
                                      </Box> */}
                                    <Box px={0}>
                                      <Typography variant="caption" fontWeight="regular">
                                        PRODUCT OPTIONS
                                      </Typography>
                                    </Box>
                                    <Box mt={2}>
                                      <Grid container spacing={{ xs: 1, md: 3 }}>
                                        {campaignProductVariants.map((variant) => (
                                          <Grid item xs={12} md={6} lg={6}>
                                            <TextField
                                              sx={{
                                                padding: "12px",
                                                paddingLeft: "3px",
                                              }}
                                              placeholder="Select product(s)"
                                              fullWidth
                                              select
                                              label={`${variant.title}`}
                                              onChange={(e) => {
                                                let optName = "";
                                                campaignProductVariants.every((v) => {
                                                  if (v.reference === variant.reference) {
                                                    v.options.every((o) => {
                                                      if (o.reference === e.target.value) {
                                                        optName = o.title;
                                                      }
                                                      return true;
                                                    });
                                                  }
                                                  return true;
                                                });
                                                const temVariants = selectCampaignProductVariants;
                                                if (temVariants.length === 0) {
                                                  const obj = {
                                                    reference: variant.reference,
                                                    variant_title: variant.title,
                                                    option: e.target.value,
                                                    option_title: optName,
                                                  };
                                                  temVariants.push(obj);
                                                  setSelectCampaignProductVariants(temVariants);
                                                  return;
                                                }

                                                let exists = null;
                                                for (const [index, row] of temVariants.entries()) {
                                                  if (row.reference === variant.reference) {
                                                    exists = index;
                                                    break;
                                                  }
                                                }

                                                if (exists !== null) {
                                                  temVariants[exists].option = e.target.value;
                                                  temVariants[exists].option_title = optName;
                                                } else {
                                                  const obj = {
                                                    reference: variant.reference,
                                                    variant_title: variant.title,
                                                    option: e.target.value,
                                                    option_title: optName,
                                                  };
                                                  temVariants.push(obj);
                                                }
                                                // console.log(temVariants);
                                                setSelectCampaignProductVariants(temVariants);
                                              }}
                                            >
                                              {variant.options.length > 0 &&
                                                variant.options.map((opt) => (
                                                  <MenuItem
                                                    name={opt.title}
                                                    // key={`${opt.reference}_${idx}`}
                                                    value={opt.reference}
                                                  >
                                                    {opt.title}
                                                  </MenuItem>
                                                ))}
                                            </TextField>
                                          </Grid>
                                        ))}
                                      </Grid>
                                    </Box>
                                    <Box mt={3} mb={3}>
                                      <Divider />
                                    </Box>
                                  </Box>
                                ) : (
                                  <> </>
                                )}
                              </Box>
                              {selectedProductObject.order_restriction === "MULTIPLE" ? (
                                <Box mt={5}>
                                  <Box px={0}>
                                    <Typography variant="caption" fontWeight="regular">
                                      PRODUCT QUANTITY
                                    </Typography>
                                  </Box>
                                  <Box mt={3}>
                                    <TextField
                                      sx={{
                                        size: {
                                          xs: "small",
                                          md: "large",
                                          lg: "large",
                                        },
                                      }}
                                      value={selectedQuantity}
                                      type="number"
                                      label="Quantity"
                                      fullWidth
                                      onChange={(e) => {
                                        const qty = parseInt(e.target.value, 10);
                                        setSelectedQuantity(qty);
                                      }}
                                    />
                                  </Box>
                                </Box>
                              ) : (
                                <> </>
                              )}
                            </Grid>
                          </Grid>
                        ) : (
                          <> </>
                        )}
                        <Box mt={5} mb={0}>
                          <Divider />
                        </Box>
                        <Box mt={5}>
                          <Box>
                            <Typography variant="caption" fontWeight={800}>
                              DESCRIPTION
                            </Typography>
                          </Box>
                          <Box mt={3}>
                            <Box mt={2}>
                              <Typography variant="caption" fontWeight="regular">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: selectedProductObject.description,
                                  }}
                                />
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </DialogContent>
              <DialogActions>
                <Box p={1}>
                  <Button
                    variant="outlined"
                    size="large"
                    color="primary"
                    startIcon={<Icon>cancel_outline</Icon>}
                    onClick={() => {
                      setSelectedProduct(null);
                      setSelectedProductObject(null);
                      setShowProductDialog(false);
                    }}
                  >
                    Cancel
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    startIcon={<Icon>add</Icon>}
                    onClick={() => {
                      addToCart();
                    }}
                  >
                    Add
                  </Button>
                </Box>
              </DialogActions>
            </Dialog>
          ) : (
            <> </>
          )}

          {campaign !== null ? (
            <Box sx={{ margin: "5px auto", maxWidth: "600px" }}>
              <Box>
                <Paper elevation={0}>
                  <Box p={2} align="center">
                    <Box>
                      {webStore === null ? (
                        <img
                          src={`${AppConfig.api_media_url}${banner}`}
                          alt="img"
                          style={{ maxWidth: "40%", maxHeight: "100%" }}
                        />
                      ) : (
                        <Box component="a" onClick={() => navigate(`/i/${webStore.reference}`)}>
                          <img
                            src={`${AppConfig.api_media_url}${webStore.logo}`}
                            alt="img"
                            style={{ maxWidth: "40%", maxHeight: "100%" }}
                          />
                        </Box>
                      )}
                    </Box>
                    <Box mt={3}>
                      <Typography variant="subtitle1" fontWeight={500}>
                        {webStore === null ? campaign.account.name : webStore.title}
                      </Typography>
                    </Box>
                    <Box mt={1}>
                      <Typography variant="caption" fontWeight={350}>
                        {campaign.title}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Box>
              {campaign.description.length > 0 ? (
                <Box mt={3}>
                  <Paper elevation={3}>
                    <Box p={2}>
                      <Box>
                        <Typography variant="caption" fontWeight="regular">
                          DESCRIPTION
                        </Typography>
                      </Box>
                      <Box mt={2}>
                        <Typography variant="caption" fontSize={12}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: campaign.description,
                            }}
                          />
                        </Typography>
                      </Box>
                    </Box>
                  </Paper>
                </Box>
              ) : (
                <> </>
              )}
              <Box mt={5}>
                <Paper elevation={3}>
                  <Box p={2}>
                    <Box>
                      <Typography variant="caption" fontWeight="regular">
                        PRODUCTS
                      </Typography>
                    </Box>
                    {/* <Box mt={3} mb={3}>
                      <TextField
                        value={selectedProduct}
                        fullWidth
                        select
                        label="Select a product"
                        onChange={(e) => {
                          setSelectedProduct(e.target.value);
                        }}
                        TextFieldProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Icon>receipt</Icon>
                            </InputAdornment>
                          ),
                        }}
                      >
                        {
                          // --> Notice below changes
                          products.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            products.map((record) => (
                              <MenuItem
                                key={record.reference}
                                value={record.reference}
                              >
                                <span>
                                  {record.title}
                                  <br />
                                  {currency.symbol}
                                  {(record.price / 100).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </span>
                              </MenuItem>
                            ))
                        }
                      </TextField>
                    </Box> */}
                    <Box mt={3} mb={3}>
                      <Autocomplete
                        value={selectedProductObject}
                        disablePortal
                        id="combo-box-demo"
                        fullWidth
                        options={products}
                        // options={products}
                        getOptionLabel={(option) => option.title}
                        renderInput={(params) => (
                          <TextField {...params} label="Select product(s)" />
                        )}
                        renderOption={(props, record) => (
                          <div {...props} key={record.reference} value={record.reference}>
                            <Typography variant="subtitle2" fontWeight={350}>
                              {record.title}
                              <br />
                              {record.is_price_fixed ? (
                                <span>
                                  <b>
                                    {currency.symbol}
                                    {(record.price / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </b>
                                </span>
                              ) : (
                                <> &nbsp; </>
                              )}
                            </Typography>
                          </div>
                        )}
                        // getOptionKey={(option) => option.reference}
                        onChange={(event, value) => {
                          // console.log(value);
                          setSelectedProduct(value.reference);
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Icon>explore</Icon>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                    {checkoutProducts.length > 0 ? (
                      <Box mt={5} mb={3}>
                        <Box mt={3} mb={5}>
                          <Divider />
                        </Box>
                        <Box>
                          <Typography variant="caption" fontWeight="regular">
                            ORDER ITEMS
                          </Typography>
                        </Box>
                        <Box>
                          <List disablePadding>
                            {checkoutProducts.map((product, index) => (
                              <ListItem key={product.reference} sx={{ py: 1, px: 0 }}>
                                <ListItemIcon>
                                  <img
                                    src={`${AppConfig.api_media_url}${product.image}`}
                                    alt={product.name}
                                    width="36px"
                                  />
                                </ListItemIcon>
                                <ListItemText
                                  sx={{ mr: 2 }}
                                  primary={
                                    <Typography variant="subtitle2" fontSize={11} fontWeight={400}>
                                      {product.name}
                                    </Typography>
                                  }
                                  secondary={
                                    <Box mt={1}>
                                      <Typography fontSize={10}>
                                        {product.variants.map((variant) => (
                                          <>
                                            {variant.variant_title}
                                            :&nbsp;{variant.option_title}
                                            &nbsp;|&nbsp;
                                          </>
                                        ))}
                                        {`Quantity: ${product.quantity}`}
                                      </Typography>
                                    </Box>
                                  }
                                />
                                <Box>
                                  <Box mt={0}>
                                    <Typography variant="subtitle2" fontWeight="medium">
                                      <small>{currency.symbol}</small>
                                      {(product.amount / 100).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}
                                    </Typography>
                                  </Box>
                                  <Box mt={0.5} align="right">
                                    <IconButton
                                      onClick={() => {
                                        if (window.confirm("Remove item?") === true) {
                                          removeFromCart(index);
                                        }
                                      }}
                                    >
                                      <Icon color="error">cancel</Icon>
                                    </IconButton>
                                  </Box>
                                </Box>
                              </ListItem>
                            ))}
                          </List>
                        </Box>
                        <Box mt={2}>
                          <Divider />
                        </Box>
                        <Box mt={3} align="right">
                          <Typography variant="caption" fontSize={18}>
                            <small>Total:</small> <small>{currency.symbol}</small>
                            {(totalAmount / 100).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <> </>
                    )}
                  </Box>
                </Paper>
              </Box>

              {/* {checkoutProducts.length > 0 ? (
                <Box mt={5} mb={3}>
                  <Paper elevation={3}>
                    <Box p={3}>
                      <Box>
                        <Typography variant="caption" fontWeight="regular">
                          ORDER INFORMATION
                        </Typography>
                      </Box>
                      <Box>
                        <List disablePadding>
                          {checkoutProducts.map((product, index) => (
                            <ListItem
                              key={product.reference}
                              sx={{ py: 1, px: 0 }}
                            >
                              <ListItemIcon>
                                <img
                                  src={`${AppConfig.api_media_url}${product.image}`}
                                  alt={product.name}
                                  width="48px"
                                />
                              </ListItemIcon>
                              <ListItemText
                                sx={{ mr: 2 }}
                                primary={product.name}
                                secondary={
                                  <Box mt={1}>
                                    <Typography fontSize={10}>
                                      {product.variants.map((variant) => (
                                        <>
                                          {variant.variant_title}
                                          :&nbsp;{variant.option_title}
                                          &nbsp;|&nbsp;
                                        </>
                                      ))}
                                      {`Quantity: ${product.quantity}`}
                                    </Typography>
                                  </Box>
                                }
                              />
                              <Box>
                                <Box mt={1}>
                                  <Typography
                                    variant="body1"
                                    fontWeight="medium"
                                  >
                                    <small>{currency.symbol}</small>
                                    {(
                                      (product.amount * product.quantity) /
                                      100
                                    ).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </Typography>
                                </Box>
                                <Box mt={-1} align="right">
                                  <IconButton
                                    onClick={() => {
                                      if (
                                        window.confirm("Remove item?") === true
                                      ) {
                                        removeFromCart(index);
                                      }
                                    }}
                                  >
                                    <Icon color="error">cancel</Icon>
                                  </IconButton>
                                </Box>
                              </Box>
                            </ListItem>
                          ))}
                        </List>
                      </Box>
                    </Box>
                  </Paper>
                </Box>
              ) : (
                <> </>
              )} */}

              {/* {selectedProduct !== null ? (
                <Box mt={3} mb={3}>
                  <Paper sx={{ height: "100%", marginTop: "0px" }}>
                    <Box p={3}>
                      <TextField
                        value={selectedQuantity}
                        type="number"
                        label="Product Quantity"
                        fullWidth
                        onChange={(e) =>
                          setSelectedQuantity(parseInt(e.target.value, 10))
                        }
                      />
                    </Box>
                  </Paper>
                </Box>
              ) : (
                <> </>
              )} */}

              {dataForm !== null && (
                // <form id={dataForm.reference}>
                <form id="dataForm">
                  {dataFormSections.map((section) => (
                    <Box mt={5} mb={3}>
                      <Paper elevation={3}>
                        <Box px={3} py={3}>
                          {section}
                        </Box>
                      </Paper>
                    </Box>
                  ))}
                </form>
              )}

              {shippingRequired && (
                <Box mt={5} mb={5}>
                  <Paper elevation={3}>
                    <Box p={3}>
                      <Typography variant="caption" fontWeight="regular">
                        SHIPPING INFORMATION
                      </Typography>
                      <Box mt={2} mb={2}>
                        <Box mb={2}>
                          <TextField
                            name="recipient_name"
                            value={shippingRecipientName}
                            margin="dense"
                            label="Receiver's Name"
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setShippingRecipientName(e.target.value)}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Icon>person</Icon>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>
                        <Box mb={2}>
                          <TextField
                            name="phone_number"
                            value={shippingRecipientPhoneNumber}
                            margin="dense"
                            label="Receiver's Phone Number"
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setShippingRecipientPhoneNumber(e.target.value)}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Icon>phone</Icon>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>
                        <Box mb={2}>
                          <GoogleAddressField
                            displayName="Receiver's Address"
                            setAddress={setShippingAddress}
                            setLatitude={setShippingLatitude}
                            setLongitude={setShippingLongitude}
                          />
                        </Box>
                        {shippingRate === null && (
                          <>
                            <Box mb={2}>
                              <TextField
                                name="shipping_city"
                                value={shippingCity}
                                margin="dense"
                                label="Shipping City"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setShippingCity(e.target.value)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>place</Icon>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Box>
                            <Box mb={2}>
                              <TextField
                                name="shipping_state"
                                value={shippingState}
                                margin="dense"
                                label="Shipping State"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setShippingState(e.target.value)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>explore</Icon>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Box>
                          </>
                        )}
                      </Box>
                    </Box>
                  </Paper>
                </Box>
              )}

              {shippingRate !== null && (
                <Box mt={5} mb={5}>
                  <Paper elevation={3}>
                    <Box px={3} py={3}>
                      <Typography variant="caption" fontWeight="regular">
                        SHIPPING OPTIONS
                      </Typography>
                      <Box mt={2} mb={2}>
                        <Box mt={5} mb={3}>
                          <Box mt={3}>
                            <TextField
                              value={selectedShippingState}
                              fullWidth
                              select
                              label="Select State"
                              onChange={(e) => {
                                setSelectedShippingState(e.target.value);
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Icon>explore</Icon>
                                  </InputAdornment>
                                ),
                              }}
                            >
                              {
                                // --> Notice below changes
                                shippingStates.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  shippingStates.map((record) => (
                                    <MenuItem key={record.reference} value={record.reference}>
                                      {record.title}
                                    </MenuItem>
                                  ))
                              }
                            </TextField>
                          </Box>
                          <Box mt={5}>
                            <TextField
                              value={selectedShippingStateOption}
                              fullWidth
                              select
                              label="Select Location"
                              onChange={(e) => {
                                setSelectedShippingStateOption(e.target.value);
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Icon>place</Icon>
                                  </InputAdornment>
                                ),
                              }}
                            >
                              {
                                // --> Notice below changes
                                shippingStateOptions.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  shippingStateOptions.map((record) => (
                                    <MenuItem key={record.reference} value={record.reference}>
                                      <Typography variant="caption" fontWeight={500} fontSize={14}>
                                        {record.title}
                                        <br />
                                        <b>
                                          Shipping Fee:&nbsp;
                                          {currency.symbol}
                                          {(record.amount / 100).toLocaleString("en", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })}
                                        </b>
                                      </Typography>
                                    </MenuItem>
                                  ))
                              }
                            </TextField>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                </Box>
              )}

              <Box mt={5} mb={5}>
                <Paper elevation={3}>
                  <Box px={3} py={3}>
                    {customerPool !== null && (
                      <Box>
                        <Typography variant="caption" fontWeight="regular">
                          PAYER ACCESS
                        </Typography>
                        <Box mt={2} mb={3}>
                          <TextField
                            name={customerPool.reference}
                            margin="dense"
                            label={customerPool.customer_identifier}
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setCustomerPoolValue(e.target.value)}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Icon>info</Icon>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>
                      </Box>
                    )}

                    {customerRequired && (
                      <Box>
                        <Typography variant="caption" fontWeight="regular">
                          PAYER INFORMATION
                        </Typography>
                        <Box mt={2} mb={2}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <TextField
                                name="last_name"
                                margin="dense"
                                label="Last Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setLastName(e.target.value)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>person</Icon>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <TextField
                                name="first_name"
                                margin="dense"
                                label="First Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setFirstName(e.target.value)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>person_outline</Icon>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Box>
                        <Box mb={2}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <TextField
                                name="email_address"
                                margin="dense"
                                label="Email Address"
                                type="email"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setEmailAddress(e.target.value)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>email</Icon>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <TextField
                                name="phone_number"
                                margin="dense"
                                label="Phone Number"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>phone</Icon>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    )}
                    {showPaymentMethods && (
                      <Box mt={5} mb={3}>
                        <Typography variant="caption" fontWeight="regular">
                          PAYMENT METHOD
                        </Typography>
                        <Box mt={3}>
                          <TextField
                            fullWidth
                            select
                            label="How do you want to pay?"
                            onChange={(e) => {
                              setPaymentMethod(e.target.value);
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Icon>payment</Icon>
                                </InputAdornment>
                              ),
                            }}
                          >
                            {
                              // --> Notice below changes
                              campaignPaymentMethods.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                campaignPaymentMethods.map((record) => (
                                  <MenuItem key={record.value} value={record.value}>
                                    {record.name}
                                  </MenuItem>
                                ))
                            }
                          </TextField>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Box>
              <Box mt={7} align="center">
                <Button
                  size="large"
                  sx={{ width: { xs: "100%", md: "100%", lg: "100%" } }}
                  endIcon={<Icon>payment</Icon>}
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    buy();
                  }}
                >
                  Proceed
                </Button>
              </Box>
            </Box>
          ) : (
            <> </>
          )}
        </Container>
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default CampaignCheckout;
